<template>
    <div class="summary">
        <div v-if="loading === false" class="flex-ns">
            <div class="w-100 w-70-ns pr4-ns">
                <div class="summary__item">
                    <div v-html="strings['are_you_correct_user']"></div>
                </div>
                <div class="summary__item">
                    <div class="flex-ns justify-between mb2">
                        <h2>1. {{ strings['summary_addresses_shipping'] }}</h2>
                        <span class="underline" v-on:click="activeNote" style="cursor: pointer">{{
                            strings['added_shipping_notes'] }}</span>
                    </div>


                    <div class="pt2 pb3">
                        <div v-if="address.list.length > 0">
                            <div class="pl3-ns">
                                <div class="pb1 ttu" v-if="address.same && address.alternativeChecked">{{
                                    strings['summary_addresses_invoice'] }}</div>
                                <div class="pb1 ttu" v-else>{{ strings['summary_addresses_shipping'] }}</div>
                                <div class="flex flex-wrap">
                                    <address-item v-for="(info, key) in address.list" v-bind:address="info" v-bind:strings="strings" v-bind:key="key" v-bind:selected="paymentaddress" v-bind:alternative="false" v-on:set-address-on="chageAddress" class="pr4 pb3">
                                    </address-item>
                                </div>
                            </div>
                            <div v-if="noaddress" class="pl3">
                                <span class="underline" style="cursor: pointer" v-on:click="$emit('change-new-address')">Change</span>
                            </div>
                            <div class="pl3-ns pt4" v-if="address.same && address.alternativeChecked">
                                <div class="pb1 ttu">{{ strings['summary_addresses_shipping'] }}</div>
                                <address-item v-bind:address="address.alternative" v-bind:strings="strings" v-bind:alternative="true"></address-item>
                            </div>
                            <div v-if="address.list.length < 5" class="pl3-ns pt4" v-html="strings['guest_address']"></div>
                        </div>
                        <div v-else>
                            <address-map v-bind:address="addressempty" v-bind:strings="strings" v-bind:countries="address.countries" v-bind:country="cart.country.iso" v-on:check="$emit('check-new-address')"></address-map>
                        </div>
                    </div>


                    <div class="pl3-ns" v-if="notes">
                        <div class="form-group">
                            <label class="control-label ttu" for="notes">{{ strings['shipping_notes'] }}</label>
                            <textarea class="form-control" id="notes" v-model="address.note"></textarea>
                        </div>
                    </div>
                    <!-- NON MOSTRARE SE IL COUNTRY NON é IT o SM -->
                    <div class="row ph2 pv3" v-if="(cart.country.iso == 'IT' || cart.country.iso == 'SM') && address.sameInvoice">
                        <div class="form-group col-xs-12">
                            <label for="choice" class="control-label">{{ strings['bill_to'] }}</label>
                            <input id="choice_person" name="choice" type="radio" value="person" v-bind:disabled="address.sameInvoice === false" v-model="address.choice">
                            <label class="control-label" for="choice_person">{{ strings['choices_person'] }}</label>
                            <input id="choice_company" name="choice" type="radio" value="company" v-bind:disabled="address.sameInvoice === false" v-model="address.choice">
                            <label class="control-label" for="choice_company">{{ strings['choices_company'] }}</label>
                        </div>
                        <div class="form-group col-xs-12 col-md-6">
                            <label for="company_name" class="control-label">{{ strings['company_name'] }}</label>
                            <input class="form-control" v-bind:disabled="address.sameInvoice === false" name="company_name" type="text" v-model="address.companyName" id="company_name">
                        </div>
                        <div class="form-group col-xs-12 col-md-6">
                            <label for="tax_code" class="control-label">Codice fiscale</label>
                            <input class="form-control" v-bind:disabled="address.sameInvoice === false" name="tax_code" type="text" v-model="address.taxCode" id="tax_code">
                        </div>
                        <div class="form-group col-xs-12 col-md-6" v-bind:class="{ disabled: address.sameInvoice === false || address.choice == 'person' }">
                            <label for="vat_number" class="control-label">Partita IVA</label>
                            <input class="form-control" v-bind:disabled="address.sameInvoice === false || address.choice == 'person'" name="vat_number" type="text" v-model="address.vatNumber" id="vat_number">
                        </div>
                        <div class="form-group col-xs-12 col-md-6" v-bind:class="{ disabled: address.sameInvoice === false || address.choice == 'person' }">
                            <label for="pec_email" class="control-label">Email PEC</label>
                            <input class="form-control" v-bind:disabled="address.sameInvoice === false || address.choice == 'person'" name="pec_email" type="email" v-model="address.pecEmail" id="pec_email">
                        </div>
                        <div class="form-group col-xs-12 col-md-6" v-bind:class="{ disabled: address.sameInvoice === false || address.choice == 'person' }">
                            <label for="codice_univoco_fatturazione" class="control-label">Codice Univoco
                                Fatturazione</label>
                            <input class="form-control" v-bind:disabled="address.sameInvoice === false || address.choice == 'person'" name="codice_univoco_fatturazione" type="text" v-model="address.sdi" id="codice_univoco_fatturazione">
                        </div>
                    </div>
                    <div class="flex-ns pt3 pl3-ns">
                        <div class="form-group form-group--mb0 mr5-ns mr3">
                            <input id="same" name="same" type="checkbox" v-model="address.same">
                            <label for="same" class="control-label">{{ strings['invoice_same_as_shipping'] }}</label>
                        </div>
                        <div v-if="(cart.country.iso == 'IT' || cart.country.iso == 'SM')" class="form-group form-group--mb0">
                            <input id="same_invoice" name="same_invoice" type="checkbox" v-model="address.sameInvoice">
                            <label for="same_invoice" class="control-label">{{ strings['invoice_same'] }}</label>
                        </div>
                    </div>
                </div>
                <div class="summary__item" v-if="address.same && address.alternativeChecked === false">
                    <div class="pl3-ns pt3">
                        <div class="pb1 ttu">{{ strings['insert'] }} {{ strings['summary_addresses_shipping'] }}</div>
                        <div class="pb1 i pb3">{{ strings['shipping_remaind'] }}</div>
                        <address-map v-bind:address="address.alternative" v-bind:strings="strings" v-bind:countries="address.countries" v-bind:country="cart.country.iso" v-on:check="$emit('check-address')"></address-map>
                    </div>
                </div>
                <div class="summary__item">
                    <h2>3. {{ strings['review_the_articles'] }}</h2>
                    <div class="cart-items-list">
                        <cart-item v-for="(product, key) in cart.items" v-bind:product="product" v-bind:currency="cart.currency" v-bind:strings="strings" v-bind:key="key" v-bind:recap="true" v-on:add="$emit('update-item', key, 'add')" v-on:remove="$emit('update-item', key, 'remove')"></cart-item>
                    </div>
                </div>
            </div>
            <div class="w-100 w-30-ns mt0-ns mt3">
                <vue-sticky-sidebar v-bind:containerSelector="classStiky">
                    <div class="summary__item">
                        <div class="summary__button" v-bind:class="{ show: checkout.showPaymantButton }">
                            <div ref="paypalButton"></div>
                            <div ref="payButton" v-html="paymentbutton"></div>
                        </div>
                        <div v-if="checkout.showPaymantButton == false">
                            <button class="btn btn-primary w-100" v-on:click="checkButton" style="padding: 10px">{{
                                strings['pay'] }}</button>
                            <div class="pt3">

                                <div class="form-group">
                                    <input id="read_agree" name="read_agree" type="checkbox" v-model="checkout.readAgree">
                                    <label for="read_agree" class="control-label" v-html="strings['selling_conditions']"></label>
                                    <span v-if="checkAgree" class="help-block error-help-block">{{
                                        strings['selling_conditions_error'] }}</span>
                                </div>
                                <div class="tr"><small>{{ strings['required'] }}</small></div>
                                <div class="tr" v-if="shippingrussian === true">
                                    <span v-html="strings['shipping_russian']"></span>
                                </div>
                                <div class="row" v-if="activebuy == false">
                                    <div class="col-xs-12 tc mb5 mt3">
                                        <div class="pa3" style="background-color: white">
                                            <h3><b>{{ strings['minimum_order_gb'] }}</b></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <h2 class="pb2">{{ strings['order_summary'] }}</h2>
                        <div class="flex justify-between" v-if="cart.promoCheck">
                            <span>{{ strings['coupon'] }}</span>
                            <span class="fw4">{{ cart.promoCode }}</span>
                        </div>
                        <div class="flex justify-between">
                            <span>{{ strings['articles'] }}:</span>
                            <span>{{ cart.totalItems }}</span>
                        </div>
                        <div class="flex justify-between">
                            <span>{{ strings['subtotal'] }}:</span>
                            <span>{{ cart.currency }} {{ cart.subtotal.toFixed(2) }}</span>
                        </div>
                        <div class="flex justify-between" v-if="cart.subtotalPromo > 0">
                            <span>{{ strings['promo_discount_label'] }}:</span>
                            <span>{{ cart.currency }} - {{ cart.subtotalPromo.toFixed(2) }}</span>
                        </div>
                        <div class="flex justify-between">
                            <span>{{ strings['shipping_cost'] }}:<br>({{ cart.country.name }})</span>
                            <span>{{ cart.currency }} {{ cart.shippingCost.toFixed(2) }}</span>
                        </div>
                        <hr>
                        <div class="flex justify-between">
                            <div class="summary__total">{{ strings['total'] }}:</div>
                            <div class="summary__total">{{ cart.currency }} {{ cart.total.toFixed(2) }}</div>
                        </div>
                        <div class="tr pt3 summary__scalapay" v-bind:class="{ show: scalapay }">
                            <!-- <scalapay-widget v-bind:amount="cart.total.toFixed(2)" min="35" alignment="right"  v-bind:locale="lang" number-of-installments="4"></scalapay-widget> -->
                        </div>
                    </div>
                </vue-sticky-sidebar>
            </div>
            <div class="summary__loading" v-bind:class="{ opened: loadingpage === true }">
                <div class="flex justify-center content-center items-center">
                    <div class="loader"><b>Updating...</b></div>
                </div>
            </div>
        </div>
        <div class="text-center" v-else>
            <div class="loader">Loading...</div>
        </div>
    </div>
</template>

<script>
import vueStickySidebar from "vue-sticky-sidebar"
import Swal from 'sweetalert2/dist/sweetalert2.js'
import AddressItem from './AddressItem.vue'
import AddressMap from './AddressMap.vue'
import CartPageItem from './CartPageItem'
import PaymentMethod from './PaymentMethod.vue'

function onlyLettersAndNumbers(str) {
    return /^[A-Za-z0-9]*$/.test(str);
}

// NON MOSTRARE SE IL COUNTRY NON é IT o SM
export default {
    props: [
        'addressempty',
        'noaddress',
        'cart',
        'scalapay',
        'loadingpage',
        'address',
        'paymentaddress',
        'strings',
        'loading',
        'checkout',
        'lang',
        'shippingrussian',
        'activebuy',
        'paymentbutton',
    ],
    data: function () {
        return {
            checkAge: false,
            checkAgree: false,
            notes: false,
            classStiky: (window.md.phone() ? 'false' : '.summary'), // false per disattivare lo skity
        }
    },
    watch: {
        'checkout.readAgree': function (val) {
            this.checkAgree = !val
        },
    },
    components: {
        'vue-sticky-sidebar': vueStickySidebar,
        'address-item': AddressItem,
        'address-map': AddressMap,
        'cart-item': CartPageItem,
        PaymentMethod
    },
    methods: {
        chageAddress(val) {
            if (process.env.NODE_ENV === "development") {
                console.log('chageAddress CartCheckout')
            }
            this.address.alternative = {
                name: '',
                surname: '',
                company_name: '',
                address: '',
                zip_code: '',
                district: '',
                city: '',
                country: '',
                telephone: ''
            }
            this.address.alternativeChecked = false
            this.address.same = false
            this.$emit('set-address', val)
        },
        changePayment(val) {
            if (process.env.NODE_ENV === "development") {
                console.log('changePayment', val)
            }
            this.$emit('chage-payment', val)
        },
        activeNote() {
            this.notes = !this.notes
        },
        checkButton() {
            if (window.PlUs.checkouturl === undefined) {
                if (this.checkout.readAgree && this.activebuy && this.checkout.paymentMethod != null && this.address.list.length > 0) {
                    if (this.address.sameInvoice) {
                        if (this.address.companyName.length > 2 && this.address.taxCode.length > 8 && onlyLettersAndNumbers(this.address.taxCode)) {
                            this.$emit('go-to-payment')
                        } else {
                            Swal.fire({
                                icon: 'info',
                                title: 'Attenzione',
                                text: 'Devi inserire tutti i dati di fatturazione e si prega di controllare siano corretti'
                            })
                        }
                    } else {
                        this.$emit('go-to-payment')
                    }
                } else {
                    if (process.env.NODE_ENV === "development") {
                        console.log('@checkButton else', this.address, this.checkout);
                    }
                    if (!this.checkout.readAgree) {
                        this.checkAgree = true
                    }
                    if (this.checkout.paymentMethod == null) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Attenzione',
                            text: 'Seleziona un metodo di pagamento'
                        })
                    }
                    if (this.address.list.length <= 0) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Attenzione',
                            text: 'Devi inserire un indirizzo di spedizione e salvare con il bottone conferma'
                        })
                    }
                }
            } else {
                window.location.href = window.PlUs.checkouturl;
            }
        }
    }
}
</script>
